import {getYear} from "date-fns";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const appl110ValidationSchema = () => {
  yup.setLocale({ string: {} });
  const { t } = useTranslation();
  return yup
    .object()
    .shape({
      pastApp: yup
        .object()
        .shape({ m02_id: yup.string(), label: yup.string() })
        .nullable()
        .default(undefined)
        .transform((value, originalValue) => {
          if (
            originalValue &&
            typeof originalValue === "object" &&
            Object.keys(originalValue).length === 0
          ) {
            return undefined;
          }
          return value;
        }),
      d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocPrakt1: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      d50_id2: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardDate2: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      fudocPrakt2: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      boardService: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      endOfService: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      endOfServiceNew: yup
        .date()
        .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
        .required(t("Το πεδίο είναι υποχρεωτικό")),
      keimeno: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
      newBoardMembers: yup.array().of(
        yup.object().shape({
          fp1Afm: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1Name: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1Surname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1Fathersname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1Doy: yup.object().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1Adt: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) =>
              schema.max(20).required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1Street: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1Number: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ZipCode: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) =>
              schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1City: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1Idiot: yup.object().when("fp1Afm", {
            is: (fp1Afm: string) => fp1Afm != null,
            then: (schema) =>
              schema.required(t("Το πεδίο είναι υποχρεωτικό")).shape({
                value: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
                label: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
              }),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1SoloRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1JointlyRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Afm: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2Name: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Surname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Fathersname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Doy: yup.object().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Adt: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) =>
              schema.max(20).required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Street: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Number: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ZipCode: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) =>
              schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2City: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2Idiot: yup.object().when("fp2Afm", {
            is: (fp2Afm: string) => fp2Afm != null,
            then: (schema) =>
              schema.required(t("Το πεδίο είναι υποχρεωτικό")).shape({
                value: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
                label: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
              }),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2SoloRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2JointlyRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
        }),
      ),

      newRepresentativesMembers: yup.array().of(
        yup.object().shape({
          fp1ReprAfm: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1ReprName: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprSurname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprFathersname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprDoy: yup.object().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprAdt: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprStreet: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprNumber: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprZipCode: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) =>
              schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprCity: yup.string().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprStartDate: yup.date().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) =>
              schema
                .required(t("Το πεδίο είναι υποχρεωτικό"))
                .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprEndDate: yup.date().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) =>
              schema
                .required(t("Το πεδίο είναι υποχρεωτικό"))
                .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp1ReprSoloRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp1ReprJointlyRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "ok",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2ReprAfm: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2ReprName: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprSurname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprFathersname: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprDoy: yup.object().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprAdt: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprOdos: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprArithm: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprTk: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) =>
              schema.max(12).required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprPolh: yup.string().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprStartDate: yup.date().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) =>
              schema
                .required(t("Το πεδίο είναι υποχρεωτικό"))
                .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprEndDate: yup.date().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) =>
              schema
                .required(t("Το πεδίο είναι υποχρεωτικό"))
                .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
            otherwise: (schema) => schema.nullable(),
          }),
          fp2ReprSoloRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),

          fp2ReprJointlyRepresentative: yup.number().when(["ok"], {
            is: (ok: string) => ok === "no",
            then: (schema) => schema.required(t("Το πεδίο είναι υποχρεωτικό")),
            otherwise: (schema) => schema.nullable(),
          }),
        }),
      ),
    })
    .test(
      "check-board-members",
      t("Το ΔΣ πρέπει να αποτελείται από 1 μέλος ή από 3 έως 15 μέλη."),
      function (value) {
        const members = value?.newBoardMembers || [];

        if (
          members.length === 0 ||
          members.length === 2 ||
          members.length > 15
        ) {
          return this.createError({
            message: t(
              "Το ΔΣ πρέπει να αποτελείται από 1 μέλος ή από 3 έως 15 μέλη.",
            ),
          });
        }

        let allFieldsFilled = true;

        members.forEach((member: Record<string, any>, index) => {
          Object.keys(member).forEach((key) => {
            if (
              member[key] == null ||
              member[key] === "" ||
              (key === "fp2Doy" && Object.keys(member[key]).length === 0)
            ) {
              allFieldsFilled = false;
            }
          });
        });

        return allFieldsFilled
          ? true
          : this.createError({
              message: t("Υπάρχει μη συμπληρωμένο πεδίο στα μέλη."),
            });
      },
    )
    .test(
      "valid board position",
      t(
        "Στην περίπτωση ενός μέλους ΔΣ η ιδιότητα πρέπει να είναι Σύμβουλος - Διαχειριστής.",
      ),
      (value) => {
        const melSize = Array.isArray(value?.newBoardMembers)
          ? value.newBoardMembers.length
          : 0;

        const boardPosition =
          value?.newBoardMembers?.[0]?.fp1Idiot?.value ||
          value?.newBoardMembers?.[0]?.fp2Idiot?.value;

        if (melSize === 1 && boardPosition !== "67") {
          return false;
        }

        return true;
      },
    )
    .test(
      "check representative rules",
      t(
        "Στην περίπτωση ενός μέλους ΔΣ η Εκπροσώπηση Μεμονωμένα θα πρέπει να είναι ΝΑΙ και Εκπροσώπηση Από Κοινού να είναι ΟΧΙ",
      ),
      (value) => {
        if (
          Array.isArray(value?.newBoardMembers) &&
          value?.newBoardMembers?.length === 1
        ) {
          const soloRepresentative =
            value?.newBoardMembers?.[0]?.fp1SoloRepresentative ||
            value?.newBoardMembers?.[0]?.fp2SoloRepresentative;
          const jointlyRepresentative =
            value?.newBoardMembers?.[0]?.fp1JointlyRepresentative ||
            value?.newBoardMembers?.[0]?.fp2JointlyRepresentative;

          if (!soloRepresentative || jointlyRepresentative) {
            return false;
          }
        }

        return true;
      },
    )
    .test(
      "new DS service dates entered years apart",
      t(
        "Πρέπει να συμφωνεί το έτος λήξης της θητείας του ΔΣ με το αποτέλεσμα που προκύπτει προσθέτοντας στο έτος εκλογής τα χρόνια θητείας διοικητικού συμβουλίου Σημείωση το έτος εκλογής ταυτίζεται με αυτό της απόφασης οργάνου",
      ),
      (value) => {
        const yearToCheck = getYear(value.endOfService) + parseInt(value.boardService);
        return getYear(value.endOfServiceNew) === yearToCheck
      },
    );
};
